import { render, staticRenderFns } from "./SectorManageDetail.vue?vue&type=template&id=734933e8"
import script from "./SectorManageDetail.vue?vue&type=script&lang=js"
export * from "./SectorManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports